module.exports = __webpack_public_path__ + "static/media/R-280HD_CrossSection.fa557915.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/fr/R-280HD_CrossSection.png
// module id = 493
// module chunks = 0